import classNames from 'classnames';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { Shape2, Shape2Icon, Shape2Tone } from '../Shape2/Shape2';

import './Alert.css';

export enum AlertSize {
    s = 's',
    m = 'm',
    l = 'l',
    n = 'n',
    xl = 'xl'
}

export enum AlertType {
    error = 'error',
    warning = 'warning',
    info = 'info',
    notification = 'notification',
    help = 'help'
}

export interface AlertProps {
    visible?: boolean;
    type: AlertType;
    size?: AlertSize;
    bordered?: boolean;
    iconTone?: Shape2Tone;
    icon?: Shape2Icon;
    iconSize?: number;
    className?: string;
    onClose?: () => void;
    children?: React.ReactNode;
    contentCls?: string;
}

export class Alert extends React.Component<AlertProps> {
    render() {
        const {
            visible = true,
            type,
            size = AlertSize.l,
            icon = Shape2Icon.warning,
            bordered = false,
            className,
            onClose,
            children,
            iconTone = Shape2Tone.white,
            iconSize = 16,
            contentCls
        } = this.props;

        if (!visible) {
            return false;
        }

        const closeIcon = onClose ? (
            <div className={Bem.cls('alert', 'close')} onClick={onClose}>
                <Shape2 width={16} height={16} icon={Shape2Icon.cross} tone={Shape2Tone.white} />
            </div>
        ) : (
            undefined
        );

        return (
            <div
                className={classNames(
                    Bem.cls({
                        block: 'alert',
                        mods: {
                            'has-close': !!onClose,
                            size,
                            type,
                            bordered
                        }
                    }),
                    className
                )}
            >
                <Shape2
                    cls={Bem.cls('alert', 'icon', { type, size })}
                    tone={iconTone}
                    width={iconSize}
                    height={iconSize}
                    icon={icon}
                />
                <span className={classNames(Bem.cls('alert', 'content'), contentCls)}>{children}</span>
                {closeIcon}
            </div>
        );
    }
}
